import { render, staticRenderFns } from "./PersonaDomicilioForm.vue?vue&type=template&id=49811305&scoped=true"
import script from "./PersonaDomicilioForm.vue?vue&type=script&lang=js"
export * from "./PersonaDomicilioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49811305",
  null
  
)

export default component.exports